import Vue from "vue";
import Vuex from "vuex";

import language from "./modules/language";
import authentication from "./modules/authentication";
import socialMedia from "./modules/social-media";
import common from "./modules/common";
import user from "./modules/user";
import audit from "./modules/audit";
import settings from "./modules/settings";
import service from "./modules/service";
import vacant from "./modules/vacant";
import post from "./modules/post";
import section from "./modules/section";
import product from "./modules/product";
import budget from "./modules/budget";
import contact from "./modules/contact";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    language,
    authentication,
    socialMedia,
    common,
    user,
    audit,
    settings,
    service,
    vacant,
    post,
    section,
    product,
    budget,
    contact,
  },
});
